import { forwardRef } from 'react';

type DangerousHtmlProps = {
  className?: string;
  as?: React.ElementType;
  html?: string | null;
};

/**
 * DangerousHtml component
 *
 * ! This component is used to render HTML content that is NOT sanitized. Should be used with caution.
 */
export const DangerousHtml = forwardRef(function DangerousHtml(
  { html, as, className }: DangerousHtmlProps,
  ref,
) {
  if (!html) {
    return null;
  }

  const Tag = as ?? 'div';

  return (
    <Tag
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{
        __html: html ?? '',
      }}
    />
  );
});
